import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const wrapper = css`
    margin: 1rem;
    .row,
    .col {
      margin: 0;
    }
    .col {
      padding: 0;
    }
  `;

  const title = css`
    ${theme.typography.h1}
    color: ${theme.colors.navy["1"]};
  `;

  const subtitle = css`
    ${theme.typography.h3}
    color: ${theme.colors.navy["3"]};
    font-weight: 400;
    margin-top: 4px;
  `;

  const line = css`
    background-color: ${theme.colors.gray["2"]};
    margin: 1rem 0.5r;
    width: 100%;
  `;

  const card = css`
    border-radius: 4px;
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);
    padding: 1.25em 1em;
  `;

  const cardHeader = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    h2 {
      ${theme.typography.h2}
      margin: unset;
      color: ${theme.colors.navy["1"]};
    }
  `;

  const cardTitle = css`
    display: flex;
    align-items: center;
  `;

  const cardIcon = css`
    width: 24px;
    height: 24px;
    margin-right: 0.5rem;
    color: ${theme.colors.teal["1"]};
  `;

  const emptyState = css`
    text-align: center;
    padding: 2rem 1rem;
    h3 {
      ${theme.typography.h3}
      color: ${theme.colors.navy["1"]};
    }
    p {
      ${theme.typography.p}
      color: ${theme.colors.navy["1"]};
    }
  `;

  const statusBadge = css`
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    font-family: Open Sans, sans-serif;
    text-transform: capitalize;
  `;

  const statusHealthy = css`
    ${statusBadge};
    background: ${theme.colors.seafoam["2"]};
    color: ${theme.colors.teal["1"]};
  `;

  const statusWatch = css`
    ${statusBadge};
    background: rgba(252, 210, 46, 0.25);
    color: ${theme.colors.yellow.primary};
  `;

  const statusAtRisk = css`
    ${statusBadge};
    background: rgba(185, 2, 0, 0.12);
    color: ${theme.colors.red.primary};
  `;

  const accountLink = css`
    color: ${theme.colors.teal["1"]};
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      color: ${theme.colors.teal["1"]};
      text-decoration: underline;
    }
  `;

  const numericCell = css`
    text-align: right;
  `;

  const backLink = css`
    color: ${theme.colors.teal["1"]};
    text-decoration: none;
    cursor: pointer;
    margin-bottom: 0.5rem;
    display: inline-block;
    &:hover {
      text-decoration: underline;
    }
  `;

  // Active-page green from the site sidebar (#63C4AB).
  const ACTIVE_GREEN = theme.colors.teal["2"];

  const tabsNav = css`
    border-bottom: 1px solid ${theme.colors.gray["2"]};
    margin: 0.5rem 0 1rem;
    .nav-link {
      color: ${theme.colors.navy["3"]};
      font-family: Open Sans, sans-serif;
      font-size: 14px;
      padding: 10px 16px;
      border: none;
      border-bottom: 3px solid transparent;
      margin-bottom: -1px;
      cursor: pointer;
      transition: color 0.15s ease, border-color 0.15s ease;
    }
    .nav-link:hover {
      color: ${ACTIVE_GREEN};
      border-bottom-color: ${theme.colors.gray["3"]};
    }
    .nav-link.active {
      color: ${ACTIVE_GREEN};
      border-bottom-color: ${ACTIVE_GREEN};
      font-weight: 700;
      background: transparent;
    }
  `;

  return {
    wrapper,
    title,
    subtitle,
    line,
    card,
    cardHeader,
    cardTitle,
    cardIcon,
    emptyState,
    statusHealthy,
    statusWatch,
    statusAtRisk,
    accountLink,
    numericCell,
    backLink,
    tabsNav,
  };
};

export default useStyles;
